const OrganizingTeamData = [
    {
        name: "WIlly Susilo",
        role: "Australian Laureate Fellow",
        image: require("../assets/images/OrganizingTeam/Willy.jpeg"),
        country: "Australian",
    },
    {
        name: "Khoa Nguyen",
        role: "Senior Lecturer at the University of Wollongong (UOW)",
        image: require("../assets/images/OrganizingTeam/KhoaNguyen.jpeg"),
        country: "Australian",
    },
    {
        name: "Yannan Li",
        role: "Senior lecturer in the University of Wollongong",
        image: require("../assets/images/OrganizingTeam/YannanLi.jpeg"),
        country: "Australian",
    },
    {
        name: "Partha Sarathi Roy",
        role: "Lecturer at School of Computing and Information Technology, University of Wollongong",
        image: require("../assets/images/OrganizingTeam/Partha.jpeg"),
        country: "Australian",
    },
    {
        name: "Prof. Manindra Agrawal",
        role: "Director Of IIT Kanpur",
        image: require("../assets/images/OrganizingTeam/manindraAgrawal.webp"),
        country: "Indian",
    },
    {
        name: "Prof. Sandeep Shukla",
        role: "Professor, CSE, IIT Kanpur",
        image: require("../assets/images/speakers/sandeep-shukla.jpg"),
        country: "Indian",
    },
    {
        name: "Dr. Tanima Hajra",
        role: "Chief Operating Officer at C3iHub, IIT Kanpur",
        image: require("../assets/images/speakers/tanima-hajra.jpg"),
        country: "Indian",
    },
    {
        name: "Dr. Urbi Chatterjee",
        role: "Assistant Professor, CSE, IIT Kanpur",
        image: require("../assets/images/OrganizingTeam/urbhiChatterjee.jpeg"),
        country: "Indian",
    },
    {
        name: "Dr. Adithya Vadapalli",
        role: "Assistant Professor, CSE, IIT Kanpur",
        image: require("../assets/images/OrganizingTeam/adithyaVadapalli.jpeg"),
        country: "Indian",
    },
    {
        name: "Dr. Debapriya Basu Roy",
        role: "Assistant Professor at IIT Kanpur.",
        image: require("../assets/images/OrganizingTeam/debapriya.jpeg"),
        country: "Indian",
    },
    {
        name: "Rajendra Kumar",
        role: "Assistant Professor, CSE, IIT Delhi",
        image: require("../assets/images/speakers/rajendra.jpg"),
        country: "Indian",
    },
];

export default OrganizingTeamData;
